import React, { useEffect } from 'react';
import { GetApplicationContext } from 'store/AppContext/applicationContextThunk';
import { useAppDispatch, useAppSelector } from 'store/store';
import { sgwtConnect } from 'core/services/common/sgConnect';
import { LoadingPage } from 'components/common/loading/LoadingPage';
import { shallowEqual } from 'react-redux';

export const ProtectedRoute: React.FC<{ children: React.JSX.Element }> = ({ children }) => {
    const dispatch = useAppDispatch();
    const { applicationContext, isLoading } = useAppSelector(state => ({
        applicationContext: state.applicationContext.context,
        isLoading: state.applicationContext.isLoading,
    }), shallowEqual);

    useEffect(() => {
        (async () => {
            if (!sgwtConnect?.isAuthorized()) {
                sgwtConnect?.requestAuthorization();
            }
            else if (!applicationContext && !isLoading) {
                dispatch(GetApplicationContext());
            }
        })();
    }, [applicationContext, dispatch, isLoading]);

    if (isLoading) {
        return <LoadingPage />;
    }

    return applicationContext?.user
        ? children
        : null;
};
